import { render } from "./PraticaVT4.vue?vue&type=template&id=bd4b0660&scoped=true"
import script from "./PraticaVT4.vue?vue&type=script&lang=js"
export * from "./PraticaVT4.vue?vue&type=script&lang=js"

import "./PraticaVT4.vue?vue&type=style&index=0&id=bd4b0660&lang=css"
import "./PraticaVT4.vue?vue&type=style&index=1&id=bd4b0660&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4b0660"]])

export default __exports__